module.exports = __webpack_public_path__ + "static/media/sixteenth_viewpoint_bookstore2.ba41493d.png";